import React from "react";
import { useLocation ,Link } from "react-router-dom";
import { useState } from "react";
import { useSelector ,useDispatch} from 'react-redux';
import { useTranslation } from "react-i18next";
import { logo, MenuSvg, darkLogo } from "../../assets";
import ToggleLanguages from "../utils/ToggleLanguages";
import ToggleDark from "../utils/ToggleDark";
import { useStateContext } from "../../context/ContextProvider";
import Button from "./Button";
import { LogoutUser } from "../../redux/actions/user";
import {CiLogin,CiLogout } from "../utils/icons";
import Navebar from "./Navebar";


import Navmobile from "./Navmobile";
function Header({active,DropActive}) {
  const pathname = useLocation();

  const [openNavigation, setOpenNavigation] = useState(false);
  const { currentDir, currentMode } = useStateContext();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { user ,isAuth , isAdmin} = useSelector((state) => state.Users);
  const toggleNavigation = () => {
    setOpenNavigation((prev) => !prev);
  };
const LogoutHandeler =()=>{
  dispatch(LogoutUser())

}
  const handleClick = () => {
    if (!openNavigation) return;
    setOpenNavigation(false);
  };

  return (
    <>
    <div className=" flex-col">
    <div 
        className="  bg-gradient-to-b from-color-5 to-color-6  max-h-16    items-center px-5 lg:px-10 top-0 left-0 w-full z-50 lg:py-2   dark:bg-gradient-to-b dark:from-color-9 dark:to-color-10  backdrop-blur-2xl  border border-b-1 border-t-0  border-[#ffffff1a] shadow-md  fixed flex justify-between  "

      >

        <div
          className={`flex items-center`}
        >
          <a className="lg:w-[12rem] w-[10rem] xl:mr-8" href="#hero">
            <img
              src={logo}
              height={60}
              alt="logo"
            />
          </a>
        </div>

   <Navebar active={active} DropActive={DropActive} />

        <div className="flex flex-row items-center lg:gap-5 md:gap-2 sm:gap-2 gap-5 py-2 justify-center ">
          <div
            className={`
         flex flex-row items-center lg:gap-5 md:gap-2 sm:gap-2 gap-5 justify-center `}
          >
        
            <ToggleLanguages />
      
          </div>
 

       
         
          <div className="lg:hidden flex-col">
            <MenuSvg
              className="lg:hidden"
              openNavigation={openNavigation}
              toggleNavigation={toggleNavigation}
            />{" "}
           
          </div>
        
        </div>

      </div>
    </div>
 
      <div
              className={`${openNavigation ? "lg:hidden" : "hidden"}`}
            >
              <Navmobile active={active}  DropActive={DropActive} />
            </div>
    </>
  );
}

export default Header;
